import styled from "styled-components";
import { NavLink as Link } from "react-router-dom";
import { FaBars } from "react-icons/fa"



export const Nav = styled.nav`
    background: #020f4f;
    height: 80px;
    display: flex;
    box-shadow: 0 12px 12px -12px rgba(255,255,255,.5);
    justify-content: center;
    padding: 0.5rem calc((100vw - 1000px)/2);
    z-index: 100;
    position:relative;
    top: 0;
    right: 0;
    left: 0;
    position:fixed;
    box-sizing: border-box;
`

export const NavLink = styled(Link)`
    color: #958adb;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 3rem;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    transition: all 0.01s ease-in-out;
    
    &:hover{
        color: #c4bee8;
        transition: 0.5s;

        box-shadow: 0 12px 12px -12px rgba(255,255,255,.5);

        width:100%;
        height: 100%;
        
    }
    &.active{
        transition: all 0.01s ease-in-out;
        animation: 3s linear .1s colorIt;
        color: #c4bee8;

        border-bottom: 2px solid;


        width:100%;
        height: 100%;
        
    }
    @media screen and (max-width: 768px) {
        padding: 0 1.5rem;
    }
`
export const NavLogo = styled(Link)`
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    cursor: pointer;

`

export const Bars = styled(FaBars)`
    display: none;
    color: #520e9c;

    @media screen and (max-width: 768px) {
        display: block;
        position: relative;
        top: 0;
        right: 0;
        transform: translate(0%, 50%);
        font-size: 2rem;
        cursor: pointer;
        padding-bottom: 10px;
        margin-left: auto; 
        margin-right: 0;
`

export const NavMenu = styled.div`
    display: flex;
    align-items: center;

    @media screen and (max-width: 768px) {
        display: flex;
        align-items: center;
    }
`

export const NavBtn = styled.nav`
    display: flex;
    align-items: center;


    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const NavBtnLink = styled(Link)`
    border-radius: 4px;
    background: #256cel;
    padding: 10px 22px;
    color: #fff;
    border: none;
    outline: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    &:hover{
        transition: all 0.2s ease-in-out;
        background: #fff;
        color: #010606;
    }
`
